import { render, staticRenderFns } from "./VideoCover.vue?vue&type=template&id=efe3e84a&scoped=true&"
import script from "./VideoCover.vue?vue&type=script&lang=js&"
export * from "./VideoCover.vue?vue&type=script&lang=js&"
import style0 from "./VideoCover.vue?vue&type=style&index=0&id=efe3e84a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe3e84a",
  null
  
)

export default component.exports